import { Calculator } from '@dynameat/views/reporting/models/calculator';
import { TOTAL_REVENUE } from '../../constants';
import { TotalRevenueQuery } from '../queries';

export class TotalRevenueCalculator extends Calculator {
  kpiType = TOTAL_REVENUE

  async calculateKPI() {
    const currentResponse = await this.executeUncubeQuery(TotalRevenueQuery, this.currentPeriod);
    let props;
    if (this.previousPeriod) {
      const previousResponse = await this.executeUncubeQuery(TotalRevenueQuery, this.previousPeriod);
      props = this.getData(currentResponse.data.result[0][0], previousResponse.data.result[0][0]);
    } else props = this.getDataIfNoPreviousPeriod(currentResponse.data.result[0][0]);
    return this.getModelToInstance(props);
  }

  getValueOfKpi(response) {
    return Math.round(response);
  }
}
